import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import _ from 'lodash';
import React from 'react';

require('highcharts/modules/exporting')(Highcharts);

interface IColumnChartComponentProps {
  title: string
  isLoading: boolean
  legend: boolean
  categories: string[]
  factor: string
  seriesName: string
  series: any[]
  chartHeight?: number
  htmlSubtitle?: string
  avannisAvg: string | number
  dataPoints: any[]
  noDataMessage: string
}

interface IColumnChartComponentState {
  trendChartRef: any
  trendGraphOptions: any
}

export class ColumnChartComponent extends React.Component<IColumnChartComponentProps> {
  state: IColumnChartComponentState = {
    trendChartRef: null,
    trendGraphOptions: null,
  }
  componentDidMount() {
    this.state.trendChartRef = React.createRef();

    if (this.props.dataPoints.length > 0) {
      this.setColumnGraphOptions();
    }
  }

  componentDidUpdate(prevProps: IColumnChartComponentProps, prevState: IColumnChartComponentState) {
    if (prevProps.dataPoints !== this.props.dataPoints) {
      this.setColumnGraphOptions();
    }
  }

  setColumnGraphOptions() {
    const { seriesName, title, legend, factor, chartHeight, htmlSubtitle, avannisAvg, categories, dataPoints, noDataMessage } = this.props;
    let height = 300;
    if (chartHeight && chartHeight > 0) {
      height = chartHeight;
    }

    let min = _.min(dataPoints.reduce((acc, curr) => acc.concat(curr.y), []));
    let max = _.max(dataPoints.reduce((acc, curr) => acc.concat(curr.y), []));

    const suffix = factor === '100' ? '%' : '';

    let subtitle = {};
    if (htmlSubtitle) {
      subtitle = {
        useHTML: true,
        text: htmlSubtitle
      };
    }

    let exportingOptions = {};
    let navigationOptions = {};

    if (!categories) {
      exportingOptions = {
        buttons: {
          contextButton: {
            enabled: false
          }
        }
      };
      navigationOptions = {
        buttonOptions: {
          enabled: true
        }
      };
    } else {
      exportingOptions = {
        chartOptions: {
          title: {
            style: { display: 'block' },
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                format: '{y}' + suffix
              }
            }
          },
          subtitle: {
            useHTML: true,
            text: htmlSubtitle
          }
        },
        buttons: {
          contextButton: {
            symbol: 'url(images/bars.png)',
          }
        }
      };
      navigationOptions = {
        buttonOptions: {
          verticalAlign: 'top',
          y: -10
        }
      };
    }

    if (avannisAvg !== 0 && avannisAvg < min) {
      min = avannisAvg;
    }

    if (avannisAvg !== 0 && max < avannisAvg) {
      max = avannisAvg;
    }
    if (max > 90) {
      max = 105;
    }

    const seriesArr = [{
      name: seriesName,
      data: dataPoints,
      color: '#0493FC'
    }];
    this.setState({
      trendGraphOptions: {
        lang: {
          noData: noDataMessage,
          useHTML: true
        },
        chart: {
          type: 'column',
          height,
        },
        title: {
          useHTML: true,
          text: title,
          x: 0,
          y: 5,
          align: 'left',
          style: { display: 'none' },
        },
        subtitle,
        legend: {
          enabled: legend,
        },
        xAxis: {
          categories,
        },
        yAxis: {
          title: null,
          labels: {
            enabled: true
          },
          min,
          max,
          maxPadding: .45
        },
        tooltip: {
          borderWidth: 0,
          borderRadius: 0,
          shadow: false,
          useHTML: true,
          backgroundColor: 'rgba(255,255,255,0)',

          formatter() {
            let interviews = 'n/a';
            if (this.point.interviews) {
              interviews = this.point.interviews;
            }
            let html = '<div style="padding: 5px;">' + this.x + '<br/><span class="tooltip-interviews" style="font-size: 18px; font-weight: bold">' + this.point.y + suffix + '</span><br/>';
            if (interviews !== 'n/a') {
              html += 'Surveys: ' + interviews;
            }

            html += '</div>';
            return html;
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: '{point.y:,.0f}%',
              textShadow: false,
            }
          }
        },
        credits: {
          enabled: false
        },
        series: seriesArr,
        exporting: exportingOptions,
        navigation: navigationOptions
      }
    });
  }

  setDataPoints(series: any[]) {
    this.setState({ dataPoints: series });
  }

  render() {
    const { trendGraphOptions, trendChartRef } = this.state;

    return (
      <div>
        <section className="highcharts-component">
          {
            (trendGraphOptions && trendChartRef) &&
            <HighchartsReact
              highcharts={Highcharts}
              options={trendGraphOptions}
              allowChartUpdate={true}
              ref={trendChartRef}
            />
          }
        </section>
      </div>
    );
  }
}
